import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import { sendTaggingInfo } from './utils';

function Checkbox({
  className,
  id,
  name,
  children,
  error,
  onChange,
  formProps,
  value,
  disabled,
}) {
  const [isChecked, setIsChecked] = useState(value);
  const taggingInfo = {
    componentVariation: 'all',
    componentContent: '',
    componentProduct: '',
    componentName: name,
  };
  const handleOnChange = (event) => {
    const { checked: isCheckedAux } = event.target;
    sendTaggingInfo(
      { ...taggingInfo, componentContent: `check-${isCheckedAux}` },
      'change'
    );
    onChange(event);
  };

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  return (
    <div className={`checkbox-wrapper ${className}`} data-cy={id}>
      <label htmlFor={name} data-cy={`${id}__label`}>
        <input
          {...formProps}
          className={`${error ? 'error' : ''} ${isChecked ? 'checked' : ''}`}
          id={name}
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={handleOnChange}
          data-cy={`${id}__input`}
          disabled={disabled}
        />
        {children && <div className="labelText">{children}</div>}
      </label>
      {error && (
        <Text
          className="checkbox-wrapper_error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      <style jsx>{`@import "styles/colors.scss";

.checkbox-wrapper label {
  cursor: pointer;
  display: flex;
  align-items: start;
}
.checkbox-wrapper input[type='checkbox'] {
  -webkit-appearance: none;
  appearance: none;
  min-width: 1.25rem;
  min-height: 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.625rem;
  border: 0.0625rem solid $color--grey4;
  border-radius: 0.125rem;
  outline: none;
  cursor: pointer;
  background-color: $color--white;
}
.checkbox-wrapper input[type='checkbox']:focus {
  border: 0.0625rem solid $color--movistar_blue;
}
input.checked {
  background-color: $color--movistar_blue !important;
  border: 0.0625rem solid $color--movistar_blue !important;
  position: relative;
}
input.error {
  border: 0.0625rem solid $color--red !important;
}
.checkbox-wrapper input[type='checkbox'] .checked {
}

.checkbox-wrapper .labelText {
  display: inline;
}

input.checked::before {
  content: '';
  display: block;
  width: 0.8125rem;
  height: 0.4375rem;
  border: 0.125rem solid #fff;
  border-top: none;
  border-right: none;
  -webkit-transform: rotate(315deg);
  -ms-transform: rotate(315deg);
  transform: rotate(315deg);
  position: absolute;
  top: 0.25rem;
  left: 0.1875rem;
  background-color: transparent;
}

:global(.checkbox-wrapper_error) {
  padding: 0.125rem 0 0 1.875rem;
}
`}</style>
    </div>
  );
}
Checkbox.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  className: '',
  checked: false,
  error: '',
  onChange: () => {},
};
export default Checkbox;
